import { useState } from "react";
import { Field, Formik } from "formik";
import { SingleSectionElement } from "features/addingMeasurement";
import { Switch, Input, Button } from "components";
import { useSearchParams } from "react-router-dom";
import { ScrollToError } from "utils";
import { usePutExternalDoorsReplacementInstallationInfo } from "hooks/measurements";
import { VALIDATION_MESSAGES } from "enums";
import * as Yup from "yup";

interface ExternalDoorReplacementInstallationInformationType {
  measurementUuid: string | null;
  measurementInfo: any;
  step: number;
  setStep(step: number): void;
  prevStep: () => void;
}

const ExternalDoorReplacementInstallationInformation = ({
  measurementUuid,
  measurementInfo,
  setStep,
  step,
  prevStep,
}: ExternalDoorReplacementInstallationInformationType) => {
  const [isValidated, setIsValidated] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const initialMeasurementInstallationInfo =
    measurementInfo?.measurementInstallationInfo;

  const { mutate: updateInstallationInfo } =
    usePutExternalDoorsReplacementInstallationInfo({
      onSuccess: () => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set("measurementPage", "4");
        setSearchParams(newSearchParams, { replace: true });
        setStep(step + 1);
      },
    });

  const handleOnSubmit = (values: any) => {
    updateInstallationInfo(values);
  };

  const validationSchema = Yup.object().shape({
    plannedAssemblyTime: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
    numberOfAssemblyTeams: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
  });

  return (
    <div>
      <div className="am-heading">Informacje montażowe</div>
      <Formik
        initialValues={{
          measurementUuid: measurementUuid,
          roofOverTheDoor:
            initialMeasurementInstallationInfo?.roofOverTheDoor || false,
          plannedAssemblyTime:
            initialMeasurementInstallationInfo?.plannedAssemblyTime || "",
          numberOfAssemblyTeams:
            initialMeasurementInstallationInfo?.numberOfAssemblyTeams || "",
        }}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={isValidated}
        onSubmit={async (values) => handleOnSubmit(values)}
      >
        {({
          handleSubmit,
          errors,
          submitCount,
          touched,
          values,
          setFieldValue,
        }) => {
          if (submitCount > 0) {
            setIsValidated(true);
          }
          return (
            <form
              className="amfs__form form amfs__form--external"
              onSubmit={handleSubmit}
            >
              <ScrollToError />
              <div className="kwcc__switch">
                <label className="kwcc__label">
                  Czy jest przewidziane zadaszenie nad drzwiami?
                </label>
                <Switch
                  checked={values.roofOverTheDoor}
                  name="roofOverTheDoor"
                  form={{ setFieldValue: setFieldValue }}
                />
              </div>
              <SingleSectionElement
                className="single-section-element--margin-top"
                touched={touched}
                name="plannedAssemblyTime"
                errors={errors}
              >
                <Field
                  label="Planowany czas montażu (w godzinach)"
                  name="plannedAssemblyTime"
                  maxLength={6}
                  type="number"
                  rightPlaceholder="h"
                  component={Input}
                />
              </SingleSectionElement>
              <SingleSectionElement
                className="single-section-element--margin-top disabled"
                touched={touched}
                name="numberOfAssemblyTeams"
                errors={errors}
              >
                <Field
                  label="Ilość osób potrzebnych do montażu"
                  name="numberOfAssemblyTeams"
                  maxLength={3}
                  type="number"
                  component={Input}
                />
              </SingleSectionElement>
              <div className="am__buttons">
                <Button
                  stroke
                  onClick={() => prevStep()}
                  label="Poprzedni krok"
                />
                <Button onClick={() => handleSubmit()} label="Dalej" />
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ExternalDoorReplacementInstallationInformation;
